<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Technician Services Deletion"
    @on-hide="resetFormData"
  >
    <imports-form
      destructive-subtitle="This will delete the selected technician services."
      @on-submit="createTechnicianServiceDeletionImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Technician Services Deletion Template.xlsx"
              :file-provider="$importsAPI.getTechnicianServicesDeletionTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'TechnicianServicesImportsDeleteModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'technician-services-imports-delete-modal',
    };
  },
  methods: {
    createTechnicianServiceDeletionImport(data, handleCreate) {
      handleCreate(this.$importsAPI.technicianServicesDeletionCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
